'use client';
import { useIsLG, useIsMD, useIsXL } from '@repo/ui/src/utils/useMediaQuery';
import { ImageProps } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { Tout } from './styles';

export interface FeatureCardProps {
  toutContent: ToutContentProps;
  backgroundImage: ImageProps;
  alt?: string;
  isActive?: boolean;
  index?: number;
  totalSlides?: number;
}

const FeatureCarouselCard = ({
  toutContent,
  backgroundImage,
  alt,
  isActive = false,
  index = 0,
  totalSlides = 1,
}: FeatureCardProps) => {
  const lgAndUp = useIsXL();
  const mdAndUp = useIsLG();
  const smAndUp = useIsMD();

  const backgroundImageUrl = lgAndUp
    ? buildImageSrc(backgroundImage, 1500, 9, 5)
    : mdAndUp
      ? buildImageSrc(backgroundImage, 1280, 7, 5)
      : smAndUp
        ? buildImageSrc(backgroundImage, 960, 1, 1)
        : buildImageSrc(backgroundImage, 600, 1, 1);

  return (
    <div
      className="focus:tw-outline-brand-400"
      tabIndex={-1}
      aria-hidden={!isActive}
      role="group"
      aria-label={`slide ${index + 1} of ${totalSlides}`}
    >
      <img className="tw-w-full" src={backgroundImageUrl} role="presentation" alt={alt} />
      <Tout
        dark
        divider
        narrowContent
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        align="left"
        {...toutContent}
        headingStyleVariant="h2"
        hasBackground={!!toutContent?.headerVariant}
        tabIndex={-1}
      />
    </div>
  );
};

export default FeatureCarouselCard;
